import { setVendorDetailsChangeBaseline } from '@changeTracking/pages/vendorDetails/formChangeTracking';

import {
  fetchVendorDetails,
  fetchVendorServicesList,
  fetchVendorDocuments,
} from './services';
import { setVendorDetailsStore } from './store';
import { VendorDetails } from './types';

export const updateVendorDetailsState = (updates: Partial<VendorDetails>) => {
  Object.entries(updates).forEach(([key, value]) => {
    setVendorDetailsStore('vendorDetails', key as keyof VendorDetails, value);
  });
};

export const getVendorDetails = async (vendorId: number) => {
  setVendorDetailsStore('isLoading', true);
  const res = await fetchVendorDetails(vendorId);
  if (res) {
    setVendorDetailsStore('vendorDetails', res);
    setVendorDetailsChangeBaseline(res);
  }
  setVendorDetailsStore('isLoading', false);
};

export const getVendorServicesList = async () => {
  const response = await fetchVendorServicesList();
  if (response && response.isSuccess) {
    setVendorDetailsStore('vendorServiceTypesList', response.value);
  }
};

export const getVendorDocuments = async (vendorId: number) => {
  const response = await fetchVendorDocuments(vendorId);
  if (Boolean(response)) {
    setVendorDetailsStore('vendorDocuments', response!);
  }
};
